import {
  faArrowLeft,
  faEye,
  faPencil,
  faTachometer,
  faTasks,
  faTicket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Scroll from "react-scroll";

import DataDisplayRowText from "../Reusable/DataDisplayRowText";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { getOrganizationDetailAPI } from "../../API/Organization";
import { DateTime } from "luxon";

function OrganizationDetail() {
  const { id } = useParams();

  const [errors, setErrors] = useState({});
  const [organization, setOrganization] = useState({});

  const [isFetching, setFetching] = useState(false);

  function onOrganizationDetailSuccess(response) {
    setOrganization(response);
  }

  function onOrganizationDetailError(apiErr) {
    setErrors(apiErr);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onOrganizationDetailDone() {
    setFetching(false);
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);

      setFetching(true);
      getOrganizationDetailAPI(
        id,
        onOrganizationDetailSuccess,
        onOrganizationDetailError,
        onOrganizationDetailDone
      );
    }

    return () => {
      mounted = false;
    };
  }, [id]);

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/organization" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faTicket} />
                  &nbsp;Organization
                </Link>
              </li>
              <li class="is-active">
                <Link aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faEye} />
                  &nbsp;Details
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/organization`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Organization
                </Link>
              </li>
            </ul>
          </nav>

          {/* Page */}
          <nav class="box">
            {/* Title + Options */}
            <div class="columns">
              <div class="column">
                <p class="title is-4">
                  <FontAwesomeIcon className="fas" icon={faTasks} />
                  &nbsp;Organization
                </p>
              </div>
              <div class="column has-text-right">
                <Link
                  class="button is-small is-warning is-fullwidth-mobile"
                  type="button"
                >
                  <FontAwesomeIcon className="mdi" icon={faPencil} />
                  &nbsp;Edit Organization
                </Link>
              </div>
            </div>

            {/* Tab Navigation */}

            {isFetching ? (
              <PageLoadingContent displayMessage={"Please wait"} />
            ) : (
              <>
                {organization && (
                  <div class="columns">
                    <div class="column">
                      <p class="subtitle">
                        <FontAwesomeIcon className="fas" icon={faEye} />
                        &nbsp;Details
                      </p>
                      <DataDisplayRowText
                        label="Organization ID"
                        name="id"
                        placeholder="Text input"
                        value={organization.uniqueId}
                        maxWidth="260px"
                        disabled={true}
                      />

                      <DataDisplayRowText
                        label="Organization Name"
                        placeholder="0 or 1"
                        value={organization.organizationName}
                      />

                      <DataDisplayRowText
                        label="Invite Code"
                        value={organization.inviteCode}
                      />
                      <DataDisplayRowText
                        label="Employees Count"
                        placeholder="Employees Count"
                        value={organization.employeesCount}
                      />
                      <DataDisplayRowText
                        label="Created At"
                        placeholder="Created At"
                        type="text"
                        value={DateTime.fromSeconds(
                          parseInt(organization.createdAt)
                        ).toLocaleString(DateTime.DATETIME_MED)}
                      />

                      <div class="columns">
                        <div class="column is-half">
                          <Link
                            to="/organization"
                            class="button is-fullwidth-mobile"
                          >
                            <FontAwesomeIcon
                              className="fas"
                              icon={faArrowLeft}
                            />
                            &nbsp;Back to Organization
                          </Link>
                        </div>
                        <div class="column is-half has-text-right">
                          <Link class="button is-warning is-fullwidth-mobile">
                            <FontAwesomeIcon className="fas" icon={faPencil} />
                            &nbsp;Edit
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

export default OrganizationDetail;
